import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon DownloadIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const DownloadIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 19">
      <path d="M19.3 17.05H.7a.7.7 0 000 1.4h18.6a.7.7 0 000-1.4zm-9.79-3.46a.54.54 0 00.22.15.64.64 0 00.54 0 .54.54 0 00.22-.15l4.65-4.65a.69.69 0 10-1-1l-3.44 3.48V.7a.7.7 0 10-1.4 0v10.72L5.84 8a.69.69 0 10-1 1z" />
    </Icon>
  )
}
export default DownloadIcon
